<p-dialog [(visible)]="exibeFiltros" [style]="{width: '900px'}" header="Filtros" [modal]="true" styleClass="p-fluid"
  (onHide)="hideDialog()">
  <ng-template pTemplate="content">
    <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col-6">
        <label>Regional:</label>
        <input type="text" pInputText [(ngModel)]="filtros.descricaoRegiao" maxlength="100">
      </div>
      <div class="p-field p-col-6">
        <label>Nome Contato:</label>
        <input type="text" pInputText [(ngModel)]="filtros.nomeContato" maxlength="50">
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <button pButton label="Limpar" icon="pi pi-trash" class="p-button-text" (click)="limpafiltros()"></button>
    <button pButton label="Filtrar" icon="pi pi-check" class="p-button-text" (click)="enviarFiltros()"></button>
    <button pButton label="Cancelar" icon="pi pi-times" class="p-button-text" (click)="hideDialog()"></button>
  </ng-template>
</p-dialog>
